module.exports = __webpack_public_path__ + "static/wamodern-9675302cc7f43f642d54f8a78d756b28.png";